import { render, staticRenderFns } from "./print-product-design-image.vue?vue&type=template&id=2ce5544d"
import script from "./print-product-design-image.vue?vue&type=script&lang=js"
export * from "./print-product-design-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports